import StickyBanner from './stickyBanner';
import OfferBanner from './OfferBanner';
import FooterBanner from './FooterBanner';
import FixedBanner from './FixedBanner';

export { StickyBanner, OfferBanner, FooterBanner, FixedBanner };
